"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StaffLimitBreakdownScript = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _brandConfigs = require("@PetSureAustralia/petsure-brand-partner-configs/distConfigs/brandConfigs");
var _components = require("@PetSureAustralia/petsure-react-ui-library/distLib/components");
var _staffAddOnDetailsMap = require("./addons/staffAddOnDetailsMap");
var _staffModeHelpers = require("./staffModeHelpers");
var _tableContext = require("../productsTable/stateHelpers/tableContext");
var _defaultOptionalInclusions = require("./default/defaultOptionalInclusions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/* eslint-disable max-len */

var ListInclusionDetails = function ListInclusionDetails(_ref) {
  var items = _ref.items,
    code = _ref.code,
    groupIndex = _ref.groupIndex;
  return /*#__PURE__*/_react["default"].createElement("ul", null,
  // eslint-disable-next-line react/no-array-index-key
  items.map(function (item, index) {
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: "".concat(code, "_").concat(groupIndex, "_").concat(index)
    }, item);
  }));
};
ListInclusionDetails.propTypes = {
  items: _propTypes["default"].arrayOf(_propTypes["default"].string),
  code: _propTypes["default"].string,
  groupIndex: _propTypes["default"].number
};
var StaffLimitBreakdownScript = exports.StaffLimitBreakdownScript = function StaffLimitBreakdownScript(_ref2) {
  var limitBreakdown = _ref2.limitBreakdown,
    addOnKey = _ref2.addOnKey;
  var _useContext = (0, _react.useContext)(_tableContext.TableContext),
    brand = _useContext.tableContext.brand;
  var _ref3 = _brandConfigs.BrandConfigs[brand] || _brandConfigs.BrandConfigs["default"],
    customOptionalInclusions = _ref3.quoteTools.productTable.staffInstructions;
  var addOnDetails = _staffAddOnDetailsMap.StaffAddOnDetailsMap[addOnKey];
  var inclusionDetails = customOptionalInclusions || _defaultOptionalInclusions.DefaultOptionalInclusions;
  var addOnInclusionDetails = inclusionDetails[addOnKey] || [];

  /*
    If the breakdown is less than or equal to 1 then it is just an option limit
    not a proper breakdown and will have already displayed in the overall summary.
  */

  if (!limitBreakdown || !addOnDetails) {
    if (addOnInclusionDetails && addOnInclusionDetails.length > 0) {
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "This includes;", /*#__PURE__*/_react["default"].createElement(ListInclusionDetails, {
        items: addOnInclusionDetails
      }));
    }
    return null;
  }
  var breakdown = limitBreakdown.breakdown,
    planNames = limitBreakdown.planNames;
  if (!planNames.length || breakdown.length <= 1) {
    return null;
  }
  var groupLimits = breakdown.filter(function (_ref4) {
    var description = _ref4.description;
    return description === 'Routine Group';
  });
  var subLimits = breakdown.filter(function (_ref5) {
    var description = _ref5.description;
    return description !== 'Routine Group';
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "limitBreakdownScript"
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "staffScriptItem"
  }, "It is available", planNames.length === 1 ? /*#__PURE__*/_react["default"].createElement("span", null, " on a ", planNames[0], " policy only.") : /*#__PURE__*/_react["default"].createElement("span", null, " on ", (0, _staffModeHelpers.JoinWordsTogether)({
    wordsArray: planNames
  }))), groupLimits.length > 0 && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("p", {
    className: "staffScriptItem"
  }, "The options for this non-insurance benefit are as follows:"), /*#__PURE__*/_react["default"].createElement("ul", {
    className: "staffScriptItem"
  }, groupLimits.map(function (groupLimit, groupIndex) {
    var code = groupLimit.code,
      limit = groupLimit.limit;
    return (
      /*#__PURE__*/
      // eslint-disable-next-line react/no-array-index-key
      _react["default"].createElement("li", {
        key: "".concat(code, "_").concat(groupIndex)
      }, /*#__PURE__*/_react["default"].createElement("div", null, groupIndex > 0 && 'Plus ', "$", limit, " annual benefit limit for any ONE of the following:", /*#__PURE__*/_react["default"].createElement(ListInclusionDetails, {
        items: addOnInclusionDetails[code] || addOnInclusionDetails,
        code: code,
        groupIndex: groupIndex
      })))
    );
  }))), subLimits.length > 0 && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("p", {
    className: "staffScriptItem"
  }, "Plus Annual Benefits for the following:"), /*#__PURE__*/_react["default"].createElement("ul", {
    className: "staffScriptItem"
  }, subLimits.map(function (breakdownItem, index) {
    var description = breakdownItem.description,
      code = breakdownItem.code,
      limit = breakdownItem.limit;
    return (
      /*#__PURE__*/
      // eslint-disable-next-line react/no-array-index-key
      _react["default"].createElement("li", {
        key: "".concat(code, "_").concat(index)
      }, "$", limit, " for ", /*#__PURE__*/_react["default"].createElement("em", {
        className: "staffLimitDescription"
      }, " ", description.toLowerCase()), (0, _staffModeHelpers.GetSeparator)({
        fullNumber: breakdown.length,
        index: index,
        separator: ';'
      }))
    );
  }))));
};
StaffLimitBreakdownScript.propTypes = {
  limitBreakdown: _propTypes["default"].shape({
    breakdown: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      description: _propTypes["default"].string,
      code: _propTypes["default"].string,
      limit: _propTypes["default"].number
    })),
    planNames: _propTypes["default"].arrayOf(_propTypes["default"].string)
  }),
  addOnKey: _propTypes["default"].string.isRequired
};